module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1028-aa56ade1271561e243373a360ff9af59.png";